import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { NotificationBar as NotificationBar$1 } from '@grandvisionhq/common';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '../../utils/http-client.js';
import { useBloomreachLinks } from '../../hooks/use-bloomreach-links.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const CmsNotificationBar = ({ content , theme ='dark'  })=>{
    const { title , description , links  } = content;
    const [link] = useBloomreachLinks(links);
    if (!title && !description) {
        return null;
    }
    var ref;
    return /*#__PURE__*/ React.createElement(NotificationBar$1, {
        title: title,
        description: description,
        theme: theme,
        link: swcHelpers.objectSpread({}, link, {
            label: (ref = link === null || link === void 0 ? void 0 : link.label) !== null && ref !== void 0 ? ref : ''
        })
    });
};
var NotificationBar = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withEditableContent, withAnchor)(CmsNotificationBar);

export { CmsNotificationBar, NotificationBar as default };
//# sourceMappingURL=NotificationBar.js.map
